/* Korea customs gate for the cart.

   Shopify Advanced cannot extend checkout itself, so this is the last place we
   can speak to the buyer before they type an address. Two jobs: persist the
   PCCC onto the cart, and make the buyer confirm the match before checkout
   opens. Showing the block is Liquid's job, not this file's — see the snippet.

   Loaded from layout/theme.liquid rather than from the cart markup: a script
   tag inside the cart drawer does not run, which is why the first build only
   worked on /cart.

   THE CODE IS WRITTEN TWICE, on purpose.
   • As a cart attribute, so it lands on the order as its own structured field
     under Additional details — filterable, exportable, not free text.
   • Appended to the order note, because the existing fulfilment workflow reads
     the note. Writing only the attribute would have quietly broken whoever is
     looking there. The note line carries a fixed prefix so it can be found and
     replaced rather than duplicated when the buyer edits the code.

   THE CONFIRMATION IS CLEARED on any save that is not itself a confirmation.
   Otherwise a buyer who confirms, goes back and edits the code would carry the
   old confirmation forward, and that field is meant to be evidence that they
   agreed to THIS code.

   Everything is delegated from document, because the cart drawer replaces its
   markup on every change and a listener bound inside it would die. */
(function () {
  'use strict';

  if (window.__sutiKRCustoms) return;
  window.__sutiKRCustoms = true;

  var PCCC = /^P\d{12}$/;
  var ATTR = 'PCCC';
  var ATTR_OK = 'Customs confirmation';
  var NOTE_PREFIX = '개인통관고유부호 (PCCC): ';

  function block() { return document.querySelector('[data-suti-kr]'); }

  /* The dialog ships inside the cart markup so it travels with the snippet, but
     a cart morph would destroy it mid-interaction. Move it to <body> the first
     time we need it. */
  function modal() {
    var m = document.querySelector('[data-suti-kr-modal]');
    if (m && m.parentNode !== document.body) document.body.appendChild(m);
    return m;
  }

  function code() {
    var i = document.querySelector('[data-suti-pccc]');
    return i ? i.value.trim().toUpperCase() : '';
  }

  function active() {
    var b = block();
    return !!b && !b.hidden;
  }

  /* Liquid hides the block for non-KR markets. This only ever reveals it, for
     the common case of a Korean shopper browsing the US storefront, where the
     market says US right up until checkout — by which point we cannot reach
     them. It never hides, so it cannot fight a re-render. */
  function reveal() {
    var b = block();
    if (!b || !b.hidden) return;
    try {
      var langs = (navigator.languages || [navigator.language || '']).join(',');
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (/\bko\b/i.test(langs) || tz === 'Asia/Seoul') b.hidden = false;
    } catch (e) {}
  }

  function mark(valid, touched) {
    var input = document.querySelector('[data-suti-pccc]');
    var hint = document.querySelector('[data-suti-pccc-hint]');
    if (!input || !hint) return;
    var bad = touched && !valid;
    input.classList.toggle('is-bad', bad);
    hint.classList.toggle('is-bad', bad);
    hint.textContent = bad
      ? '형식을 확인해 주세요. P로 시작하고 숫자 12자리입니다.'
      : 'P로 시작하고 숫자 12자리 · "P" followed by 12 digits';
  }

  /* Remove any line we wrote before, so editing the code replaces it instead of
     stacking a second one. Anything the shopper typed themselves is untouched. */
  function stripOurs(note) {
    if (!note) return '';
    return note
      .split('\n')
      .filter(function (line) { return line.indexOf(NOTE_PREFIX) !== 0; })
      .join('\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  /* Read the current note first: /cart/update.js replaces the note outright, so
     writing without reading would wipe whatever the shopper wrote. */
  function save(c, confirmed) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; })
      .then(function (cart) {
        var kept = stripOurs(cart && cart.note);
        var valid = PCCC.test(c);
        var line = valid ? NOTE_PREFIX + c : '';
        var note = line ? (kept ? kept + '\n' + line : line) : kept;

        var attrs = {};
        attrs[ATTR] = valid ? c : '';
        attrs[ATTR_OK] = confirmed && valid ? 'Confirmed name + address match PCCC' : '';

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attrs, note: note })
        });
      })
      .catch(function () { /* never block checkout on a failed write */ });
  }

  var proceeding = false;

  function open() {
    var m = modal();
    if (!m) return;
    var shown = m.querySelector('[data-suti-krm-code]');
    var c = code();
    if (shown) shown.textContent = PCCC.test(c) ? c : '미입력';
    var agree = m.querySelector('[data-suti-krm-agree]');
    var go = m.querySelector('[data-suti-krm-go]');
    if (agree) agree.checked = false;
    if (go) go.disabled = true;
    if (typeof m.showModal === 'function') m.showModal();
    else m.setAttribute('open', '');
  }

  function close() {
    var m = document.querySelector('[data-suti-kr-modal]');
    if (!m) return;
    if (typeof m.close === 'function' && m.open) m.close();
    else m.removeAttribute('open');
  }

  /* Capture phase, so we run before the theme's own submit handling. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('#checkout, [name="checkout"]');
      if (!btn || proceeding || !active()) return;

      e.preventDefault();
      e.stopPropagation();

      if (!PCCC.test(code())) {
        mark(false, true);
        var input = document.querySelector('[data-suti-pccc]');
        if (input) {
          input.scrollIntoView({ block: 'center', behavior: 'smooth' });
          input.focus();
        }
        return;
      }

      open();
    },
    true
  );

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-suti-pccc]')) return;
    var v = t.value.trim().toUpperCase();
    mark(PCCC.test(v), v.length >= 13);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;

    if (t.matches('[data-suti-pccc]')) {
      var v = t.value.trim().toUpperCase();
      t.value = v;
      mark(PCCC.test(v), v.length > 0);
      if (PCCC.test(v)) save(v, false);
      return;
    }

    if (t.matches('[data-suti-krm-agree]')) {
      var go = document.querySelector('[data-suti-krm-go]');
      if (go) go.disabled = !t.checked;
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-suti-krm-back]')) {
      close();
      return;
    }

    if (t.closest('[data-suti-krm-go]')) {
      var c = code();
      close();
      /* Save first, then re-fire the real button with the guard down, so the
         attributes and the note are on the cart before checkout reads it. */
      save(c, true).then(function () {
        proceeding = true;
        var btn = document.querySelector('#checkout, [name="checkout"]');
        if (btn) btn.click();
        setTimeout(function () { proceeding = false; }, 4000);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('cart:update', reveal);
  document.addEventListener('cart:refresh', reveal);
  reveal();
})();
